import React from "react";
import { dangericon, error02 } from "../components/imagepath";
import { Link } from "react-router-dom";
import { useRouteError } from "react-router-dom";

const ServerError = () => {
  const error = useRouteError();
  console.error(error);

  return (
    <>
      <div className="main-wrapper error-wrapper">
        <div className="error-box">
          <img className="img-fluid" src={error02} alt="Logo" />
          <h3>
            <img className="img-fluid mb-0" src={dangericon} alt="Logo" />{" "}
            Internal Server Error
          </h3>
          <p>
            <i>{error.statusText || error.message}</i>
          </p>
          <Link to="/admin" className="btn btn-primary go-home">
            Ir a acceso
          </Link>
        </div>
      </div>
    </>
  );
};

export default ServerError;
